import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
    selector: '[datatableSorting]',
})
export class DatatableSortingDirective
{
    @Input()
    public datatableSorting: any;

    @Input()
    public column: any;

    @Output()
    public onSorted: EventEmitter<any> = new EventEmitter();

    @HostListener('click', [
        '$event',
        '$target',
    ])
    public onSortToggle(event: any): void {
        if (event) {
            event.preventDefault();
        }

        if (this.datatableSorting && this.column && this.column.sort !== false) {
            switch (this.column.sort) {
                    // Asc -> Desc
                case 'asc':
                    this.column.sort = 'desc';
                    break;
                    // Desc -> None
                case 'desc':
                    this.column.sort = 'asc';
                    break;
                    // Else -> asc
                default:
                    this.column.sort = 'asc';
                    break;
            }

            this.datatableSorting.forEach((col: any) => {
                if (col.sort !== false) {
                    col.sort = col.key !== this.column.key
                            ? ''
                            : this.column.sort;
                }
            });

            this.onSorted.emit(this.datatableSorting);
        }
    }
}
